export default {"src":"/_next/static/media/fldc.c616f881.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};